import { render, staticRenderFns } from "./leveragesPage.vue?vue&type=template&id=2488416c"
import script from "./leveragesPage.vue?vue&type=script&lang=ts"
export * from "./leveragesPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports